import { render } from "./renewal.vue?vue&type=template&id=0c4c2ca5"
import script from "./renewal.vue?vue&type=script&lang=js"
export * from "./renewal.vue?vue&type=script&lang=js"

import "./renewal.vue?vue&type=style&index=0&id=0c4c2ca5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__